import script from "./PaymentCapture20676.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentCapture20676.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentCapture20676.vue?vue&type=style&index=0&id=5963d210&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5963d210"]])

export default __exports__